import { makeRequest } from "./auth/baseCredencial";

export const apiAtualizaDados = async () => {
    return makeRequest(
            "/api/security/update-user-data", 
            {}
        );
}